import { HttpMethod } from '@previo/core'
import Http from '~/http/Http'
import { APIPaths } from '~/http/APIPaths'
import { useAuthenticationStore } from '~/store/authentication'
import type { Login, Auth } from './types'

export class AuthAPI extends Http {
  login = (code: string): Promise<Auth> => {
    return this.callNoAuthAPI<Login, Auth>(
      HttpMethod.POST,
      { path: APIPaths.USER_AUTH_LOGIN },
      {
        code,
      },
    )
  }

  logout = (): Promise<null> => {
    return this.callAuthAPI<null, null>(
      HttpMethod.DELETE,
      { path: APIPaths.USER_AUTH_LOGOUT },
      null,
    ).finally(() => {
      useAuthenticationStore.value = {
        accessToken: '',
        refreshToken: '',
      }
    })
  }
}

export const useAuthAPI = (): AuthAPI => {
  return new AuthAPI()
}
